import { Outlet, Navigate } from "react-router-dom"
import { useAuth } from "../auth/AuthContext"
import { useAuthStatus } from "../auth/useAuthStatus"
import Sidebar from  "../layout/Sidebar"

export default function DashboardLayout() {
  // 🔥 bootstrap auth status
  useAuthStatus()

  const { isLoggedIn, isChecking } = useAuth()

  if (isChecking) {
    return <div>Checking authentication…</div>
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />
  }

  return (

     <div style={{ display: "flex" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "20px" }}>
        <Outlet />
      </div>
    </div>


  )
}